<!--
 * @Date: 2019-10-08 11:21:21
 * @LastEditors  : guantingting
 * @LastEditTime : 2019-12-30 15:16:29
 -->
<template>
  <div class="loading" id="loadingComponent" :class="{ top: top, hide: !show }">
    <div class="inner">
      <div class="loading-icon"></div>
      <p class="text">努力加载中...</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading',
  props: {
    show: {
      type: [Boolean, String],
      default() {
        return true
      }
    }
  },
  data() {
    return {
      size: 24
    }
  },
  computed: {
    top() {
      return this.padTop
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/mixin.scss';
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f1f1f1;
  z-index: 200;
  transition: all 0.3s;
  .mint-spinner-fading-circle-circle::before {
    width: 10%;
    height: 25%;
  }
  .text {
    font-size: rem(24px);
    padding-top: rem(20px);
    color: #121212;
  }
  &.top {
    top: rem(80px);
  }
  &.hide {
    opacity: 0;
    z-index: -1;
  }
  .inner {
    /* width: rem(200px);
            padding: rem(30px) 0;
            background: #fff;
            border-radius: rem(5px);
            text-align: center; */
  }
  .loading-icon {
    width: rem(130px);
    height: rem(100px);
    margin: 0 auto;
    background: url('//st.haiziwang.com/static/b2c/sale/sale_common/css/images/loading.png')
      no-repeat;
    background-size: cover;
  }
  .text {
    display: none;
  }
}
</style>
